<script>
  import SelectInput from "@/components/atoms/SelectInput.vue";
  import ButtonIcon from "@/components/atoms/ButtonIcon.vue";
  import ToggleInput from "@/components/atoms/ToggleInput.vue";

  export default {
    name: "OfficeField",
    components: { SelectInput, ButtonIcon, ToggleInput },
    props: {
      offices: { type: Array, required: true },
      value: { type: Object, default: null },
      enabled: { type: Boolean, default: true },
      inOperation: { type: Boolean, default: true },
      disabled: { type: Boolean, default: false },
      editorOpen: { type: Boolean, default: false },
      editorMode: { type: String, default: null },
    },
    computed: {
      canEdit() {
        return !!(this.value && (this.value._id || this.value.officeName));
      },
      selectValue() {
        if (!this.value) return "";
        return this.value._id || this.value.officeName || "";
      },
      currentOptionLabel() {
        const id = this.selectValue;
        const opt = (this.offices || []).find((o) => o.value === id);
        return opt ? opt.label : "";
      },

      isCreateLocked() {
        return this.editorOpen && this.editorMode === "create";
      },
      isEditLocked() {
        return this.editorOpen && this.editorMode === "edit";
      },

      addBtnClass() {
        return this.isCreateLocked ? "office-field__btn--edit" : "office-field__btn--add";
      },
      editBtnClass() {
        if (!this.canEdit || this.isEditLocked) return "office-field__btn--edit";
        return "office-field__btn--add";
      },

      isAddDisabled() {
        return this.disabled || this.isCreateLocked;
      },
      isEditDisabled() {
        return !this.canEdit || this.disabled || this.isEditLocked;
      },
    },
    methods: {
      onChange(val) {
        this.$emit("select", val);
      },
      onToggleEnable(val) {
        this.$emit("update:enabled", val);
      },
      onToggleOperation(val) {
        this.$emit("update:inOperation", val);
      },
      onAdd() {
        this.$emit("add");
      },
      onEdit() {
        this.$emit("edit");
      },
    },
  };
</script>

<template>
  <div class="office-field">
    <label class="office-field__label">Sede</label>
    <div class="office-field__row">
      <SelectInput class="office-field__select" :options="offices" :value="selectValue" :key="selectValue + '|' + currentOptionLabel" :disabled="disabled" @input="onChange" />

      <ButtonIcon class="office-field__btn" :class="addBtnClass" icon="fas fa-plus" :disabled="isAddDisabled" @click="onAdd" />
      <ButtonIcon class="office-field__btn" :class="editBtnClass" icon="fas fa-pencil-alt" :disabled="isEditDisabled" @click="onEdit" />
    </div>

    <div v-if="value" class="office-field__toggles">
      <ToggleInput :value="enabled" label="Habilitada" @input="onToggleEnable" :disabled="isAddDisabled" />
      <ToggleInput :value="inOperation" label="En operación" @input="onToggleOperation" :disabled="isAddDisabled" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .office-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    &__label {
      font-family: $newFont_medium;
      font-size: 16px;
      margin-bottom: 4px;
      color: #3d3d3d;
    }
    &__row {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    &__select {
      flex: 1;
    }

    &__btn {
      border-radius: 8px;
      transition: all ease-in 0.2s;
      &--add {
        background: #bd0909;
      }
      &--edit {
        background: #c3c3c3;
      }
    }

    &__toggles {
      margin-top: 8px;
      display: flex;
      gap: 16px;
    }
  }
</style>
